<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
import axios from 'axios';
export default {
	async created () {
		this.$apimit.set(this.$getter("UserCheck"),{})
		this.getSetting();
		await this.checkLogin();
	},
	methods: {
		getSetting() {
			this.$get('sys-setting/1').then(res => {
				this.$vuex('setting', res.data, true);
			}).catch(err => {
				this.$warning(err);
			})
		},
		checkLogin(){
			if( !this.$apimit.get('Loginid') ){
				this.$router.replace("/");
			}
		},
	},
	watch:{
		'$route.path':function(path){
			this.checkLogin();
		}
	}
};
</script>